"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _validators = require("vuelidate/lib/validators");
var _components = require("@/ui/components");
var _ListTraceabilityTag = _interopRequireDefault(require("./ListTraceabilityTag"));
var _constants = require("@/config/constants");
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validateDATE = function validateDATE(value) {
  return (0, _utils.validateDateForm)(value);
};
var _default = exports.default = {
  name: 'ContentImport',
  components: {
    AppSelect: _components.AppSelect,
    AppInput: _components.AppInput,
    ListTraceabilityTag: _ListTraceabilityTag.default
  },
  data: function data() {
    return {
      dataImport: {},
      states: [],
      listEmbalagens: _constants.LIST_EMBALAGENS,
      listClientes: [],
      listProducts: [],
      plotColheita: null,
      subPlotColheita: null,
      listSubPlot: [],
      editForm: true,
      blockEdit: false,
      productId: null,
      idEdit: null,
      form: {
        provideId: null,
        clientId: null,
        includeSupplierLabel: false,
        productId: null,
        varietyId: null,
        cultivationId: null,
        packageType: '',
        NFE: '',
        portionAmount: '',
        boxQuantity: '',
        classification: null,
        netWeightBox: '',
        productCustomizationId: null,
        fabricationDate: '',
        expirationDate: '',
        typeDataManual: '',
        harvestDate: '',
        harvests: []
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listProviders', 'listCustomers', 'listProductCustomization', 'allPlots', 'listTraceabilityTagsCreate', 'GET_FARM', 'listClassifications'])), {}, {
    listVarieties: function listVarieties() {
      var _this = this;
      if (!this.form.productId) return [];
      var data = this.listProducts.find(function (item) {
        return item.id === _this.form.productId;
      });
      return data && data.varieties ? data.varieties : [];
    },
    listCultivations: function listCultivations() {
      var _this2 = this;
      if (!this.form.varietyId) return [];
      var data = this.listVarieties.find(function (item) {
        return item.id === _this2.form.varietyId;
      });
      return data ? data.cultivations : [];
    },
    showDetailClassication: function showDetailClassication() {
      if (!this.form.classification) return false;
      return true;
    },
    classificationDetail: function classificationDetail() {
      var _this3 = this;
      var item = this.listClassifications.find(function (i) {
        return i.id === _this3.form.classification;
      });
      return item;
    }
  }),
  created: function created() {
    this.loadProviders();
    this.loadCustomers();
    this.loadProducts();
    this.loadProductCustomizations();
    this.fetchPlots();
  },
  validations: {
    form: {
      provideId: {},
      clientId: {
        required: _validators.required
      },
      includeSupplierLabel: false,
      productId: {
        required: _validators.required
      },
      varietyId: {
        required: _validators.required
      },
      cultivationId: {},
      packageType: {},
      NFE: {},
      portionAmount: {},
      boxQuantity: {},
      classification: {},
      netWeightBox: {},
      productCustomizationId: {},
      fabricationDate: {
        validateDATE: validateDATE
      },
      expirationDate: {
        validateDATE: validateDATE
      },
      typeDataManual: {},
      harvestDate: {
        required: _validators.required,
        validateDATE: validateDATE
      },
      harvests: {}
    }
  },
  watch: {
    plotColheita: function plotColheita(val) {
      if (val) {
        this.loadSubPlot(val);
      }
    },
    productId: function productId(val) {
      if (val) {
        this.$v.form.productId.$model = val;
        this.getClassification(val);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchProviders', 'fetchCustomers', 'fetchProducts', 'fetchProductCustomizations', 'fetchPlots', 'fetchSubPlot', 'fetchClassifications', 'createTraceabilityTags', 'editTraceabilityTags', 'addProductTraceabilityTags', 'resetProductTraceabilityTags'])), {}, {
    returnEdit: function returnEdit() {
      this.editForm = true;
    },
    goListProducts: function goListProducts() {
      this.editForm = false;
      this.resetFormList();
    },
    setFormEdit: function setFormEdit(tag) {
      var harvestDate = tag.harvestDate ? (0, _moment.default)(tag.harvestDate).format('DD/MM/YYYY') : '';
      var expirationDate = tag.expirationDate ? (0, _moment.default)(tag.expirationDate).format('DD/MM/YYYY') : '';
      var fabricationDate = tag.fabricationDate ? (0, _moment.default)(tag.fabricationDate).format('DD/MM/YYYY') : '';
      var provideId = tag.provideId ? tag.provideId : null;
      var clientId = tag.clientId ? tag.clientId : null;
      var productId = tag.productId ? tag.productId : null;
      var varietyId = tag.varietyId ? tag.varietyId : null;
      var cultivationId = tag.cultivationId ? tag.cultivationId : null;
      var classification = tag.classification ? tag.classification : null;
      var productCustomizationId = tag.productCustomizationId ? tag.productCustomizationId : null;
      this.form = {
        provideId: provideId,
        clientId: clientId,
        includeSupplierLabel: tag.includeSupplierLabel,
        productId: productId,
        varietyId: varietyId,
        cultivationId: cultivationId,
        packageType: tag.packageType,
        NFE: tag.NFE,
        portionAmount: tag.portionAmount,
        boxQuantity: tag.boxQuantity,
        classification: classification,
        netWeightBox: tag.netWeightBox,
        productCustomizationId: productCustomizationId,
        fabricationDate: fabricationDate,
        expirationDate: expirationDate,
        typeDataManual: tag.typeDataManual,
        harvestDate: harvestDate,
        harvests: tag.harvests,
        batch: tag.batch
      };
      this.blockEdit = true;
      this.productId = productId;
      this.idEdit = tag.id;
      this.editForm = true;
    },
    getClassification: function () {
      var _getClassification = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.fetchClassifications(id);
            case 1:
              data = _context.v;
              if (!data.length) {
                this.$v.form.classification.$model = null;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getClassification(_x) {
        return _getClassification.apply(this, arguments);
      }
      return getClassification;
    }(),
    loadProviders: function () {
      var _loadProviders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchProviders();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadProviders() {
        return _loadProviders.apply(this, arguments);
      }
      return loadProviders;
    }(),
    loadCustomers: function () {
      var _loadCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.fetchCustomers();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadCustomers() {
        return _loadCustomers.apply(this, arguments);
      }
      return loadCustomers;
    }(),
    loadProductCustomizations: function () {
      var _loadProductCustomizations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.fetchProductCustomizations();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function loadProductCustomizations() {
        return _loadProductCustomizations.apply(this, arguments);
      }
      return loadProductCustomizations;
    }(),
    loadProducts: function () {
      var _loadProducts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.fetchProducts();
            case 1:
              this.listProducts = _context5.v;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function loadProducts() {
        return _loadProducts.apply(this, arguments);
      }
      return loadProducts;
    }(),
    loadSubPlot: function () {
      var _loadSubPlot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(idPlot) {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.fetchSubPlot(idPlot);
            case 1:
              data = _context6.v;
              if (data) this.listSubPlot = data;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function loadSubPlot(_x2) {
        return _loadSubPlot.apply(this, arguments);
      }
      return loadSubPlot;
    }(),
    openModalNewProvider: function openModalNewProvider() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalNewProvider,
        hasModalCard: true,
        customClass: 'modal-new-tag-template-provider',
        canCancel: ['escape'],
        props: {
          action: this.loadProviders
        }
      });
    },
    openModalNewCustomer: function openModalNewCustomer() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalNewCustomer,
        hasModalCard: true,
        customClass: 'modal-new-tag-template-customer',
        canCancel: ['escape'],
        props: {
          action: this.loadCustomers
        }
      });
    },
    openModalNewProductCustomization: function openModalNewProductCustomization() {
      if (!this.form.productId) {
        return this.$buefy.toast.open({
          message: 'Preencha o produto antes de criar a personalição',
          type: 'is-warning'
        });
      }
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalProductCustomization,
        hasModalCard: true,
        customClass: 'modal-new-product-customization',
        canCancel: ['escape'],
        props: {
          action: this.loadProductCustomizations,
          listProducts: this.listProducts,
          productSelected: this.form.productId
        }
      });
    },
    addNewHarvest: function addNewHarvest() {
      var _this4 = this;
      if (this.plotColheita) {
        var plot = this.allPlots.find(function (i) {
          return i.id === _this4.plotColheita;
        });
        var subPlot = {};
        if (this.subPlotColheita) {
          subPlot = this.listSubPlot.find(function (i) {
            return i.id === _this4.subPlotColheita;
          });
        }
        var item = {
          plot: plot.name,
          idPlot: plot.id,
          subPlot: subPlot.nickname,
          idSubPlot: subPlot.id
        };
        this.form.harvests.push(item);
        this.plotColheita = null;
        this.subPlotColheita = null;
      } else {
        this.$buefy.toast.open({
          message: 'Preencha todos os campos de informações da colheita!',
          type: 'is-warning'
        });
      }
    },
    removeItemHarvests: function removeItemHarvests(row) {
      var newItems = this.form.harvests.filter(function (i) {
        var valid = i.data === row.data && i.idPlot === row.idPlot && i.idSubPlot === row.idSubPlot;
        return !valid;
      });
      this.form.harvests = newItems;
    },
    resetAllForm: function resetAllForm() {
      this.form = {
        provideId: null,
        clientId: null,
        includeSupplierLabel: false,
        productId: null,
        varietyId: null,
        cultivationId: null,
        packageType: '',
        NFE: '',
        portionAmount: '',
        boxQuantity: '',
        classification: null,
        netWeightBox: '',
        productCustomizationId: null,
        fabricationDate: '',
        expirationDate: '',
        typeDataManual: '',
        harvestDate: '',
        harvests: []
      };
      this.blockEdit = false;
      this.$v.form.$reset();
    },
    resetFormList: function resetFormList() {
      this.form.includeSupplierLabel = false;
      this.form.productId = null;
      this.form.varietyId = null;
      this.form.cultivationId = null;
      this.form.packageType = '';
      this.form.NFE = '';
      this.form.portionAmount = '';
      this.form.boxQuantity = '';
      this.form.classification = null;
      this.form.netWeightBox = '';
      this.form.productCustomizationId = null;
      this.form.fabricationDate = '';
      this.form.expirationDate = '';
      this.form.typeDataManual = '';
      this.form.harvestDate = '';
      this.form.harvests = [];
      this.editForm = false;
      this.blockEdit = true;
      this.productId = null;
      this.$v.form.$reset();
    },
    resetForm: function resetForm() {
      this.form = {
        provideId: null,
        clientId: null,
        includeSupplierLabel: false,
        productId: null,
        varietyId: null,
        cultivationId: null,
        packageType: '',
        NFE: '',
        portionAmount: '',
        boxQuantity: '',
        classification: null,
        netWeightBox: '',
        productCustomizationId: null,
        fabricationDate: '',
        expirationDate: '',
        typeDataManual: '',
        harvestDate: '',
        harvests: []
      };
      this.editForm = true;
      this.blockEdit = false;
      this.productId = null;
      this.$v.form.$reset();
      this.resetProductTraceabilityTags();
    },
    generateBatch: function generateBatch(tag) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        var lote = '';
        // name of provider
        if (tag.provideId) {
          var nameProvider = _this5.listProviders.find(function (i) {
            return i.id === tag.provideId;
          }).name;
          var provider = nameProvider.split(' ');
          var oneLetterProvider = provider[0].slice(0, 1);
          lote += oneLetterProvider;
          if (provider.length > 1) {
            var lastLetterProvider = provider[provider.length - 1].slice(0, 1);
            lote += lastLetterProvider;
          }
        } else {
          var _nameProvider = _this5.GET_FARM.name;
          var _provider = _nameProvider.split(' ');
          var _oneLetterProvider = _provider[0].slice(0, 1);
          lote += _oneLetterProvider;
          if (_provider.length > 1) {
            var _lastLetterProvider = _provider[_provider.length - 1].slice(0, 1);
            lote += _lastLetterProvider;
          }
        }
        // name of product
        if (tag.productId) {
          var nnameProductId = _this5.listProducts.find(function (i) {
            return i.id === tag.productId;
          }).name;
          var productId = nnameProductId.split(' ');
          var oneLetterProduct = productId[0].slice(0, 1);
          lote += oneLetterProduct;
          if (productId.length > 1) {
            var lastLetterProduct = productId[productId.length - 1].slice(0, 1);
            lote += lastLetterProduct;
          }
        }
        // name of variety
        if (tag.varietyId) {
          var nameVariety = _this5.listVarieties.find(function (i) {
            return i.id === tag.varietyId;
          }).name;
          var variety = nameVariety.split(' ');
          var oneLetterVariety = variety[0].slice(0, 1);
          lote += oneLetterVariety;
          if (variety.length > 1) {
            var lastLetterVariety = variety[variety.length - 1].slice(0, 1);
            lote += lastLetterVariety;
          }
        }
        // data da colheita
        if (tag.harvestDate) {
          var harvestDate = (0, _utils.replaceAll)(tag.harvestDate, '/', '');
          lote += harvestDate;
        }
        resolve(lote);
      });
    },
    saveEtiqueta: function () {
      var _saveEtiqueta = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var dataFabrication, dataValidation, batch, data, _data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.$v.form.$touch();
              if (!this.$v.form.$invalid) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, preencha os campos obrigat\xF3rios!",
                type: 'is-danger'
              }));
            case 1:
              if (!(this.form.fabricationDate && this.form.expirationDate)) {
                _context7.n = 2;
                break;
              }
              dataFabrication = (0, _utils.convertDateISO)(this.form.fabricationDate);
              dataValidation = (0, _utils.convertDateISO)(this.form.expirationDate);
              if (!(dataValidation <= dataFabrication)) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2, this.$buefy.toast.open({
                duration: 5000,
                message: "A data de validade deve ser maior que a data de fabrica\xE7\xE3o.",
                type: 'is-danger'
              }));
            case 2:
              if (this.idEdit) {
                _context7.n = 5;
                break;
              }
              _context7.n = 3;
              return this.generateBatch(this.form);
            case 3:
              batch = _context7.v;
              this.form.batch = batch;
              _context7.n = 4;
              return this.createTraceabilityTags(this.form);
            case 4:
              data = _context7.v;
              if (data) {
                this.idEdit = null;
                this.resetFormList();
              }
              _context7.n = 7;
              break;
            case 5:
              _context7.n = 6;
              return this.editTraceabilityTags(_objectSpread(_objectSpread({}, this.form), {}, {
                id: this.idEdit
              }));
            case 6:
              _data = _context7.v;
              if (_data) {
                this.idEdit = null;
                this.resetFormList();
              }
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function saveEtiqueta() {
        return _saveEtiqueta.apply(this, arguments);
      }
      return saveEtiqueta;
    }(),
    openDetailClassication: function openDetailClassication() {
      if (!this.form.classification || !this.classificationDetail) {
        return this.$buefy.toast.open({
          message: 'Preencha o produto antes de criar a personalição',
          type: 'is-warning'
        });
      }
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalDetailClassification,
        hasModalCard: true,
        customClass: 'modal-detail-classification',
        canCancel: ['escape'],
        props: {
          link: this.classificationDetail.link
        }
      });
    }
  })
};